import { Map } from 'immutable'
import { handleActions, combineActions } from 'redux-actions'
import { combineReducers } from 'redux-immutable'

import * as actions from './actions'
import { keyBy } from 'utils/immutable'

const endUserMembership = handleActions({
  [actions.receiveEndUserMembership]: (state, { payload }) => state.set(payload.endUserId, payload.membership)
}, Map())

const byId = handleActions({
  [actions.receiveSegmentList]: (state, action) => keyBy(action.payload),
}, Map())

const segmentStatus = handleActions({
  [combineActions(
    actions.receiveSegmentList,
    actions.fetchSegmentListPending,
    actions.fetchSegmentListFailed
  )]: (state, action) => {
    return action.type 
  }
}, false)

const cardinalityByIdSet = handleActions({
  [actions.receiveSegmentSetCardinality]: (state, { payload: { segmentSet, cardinality }}) => {
    return state.set(segmentSet, cardinality)
  },
}, Map())


export default combineReducers({ endUserMembership, byId, segmentStatus, cardinalityByIdSet })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/segment/reducer.js